export default __webpack_public_path__ + "static/151-b345f0d9527e3c8f1dfe37b673cb0dce.jpg";